
import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const WalletHubSkeleton = () => {
  return (
    <div className="p-4 sm:p-6 bg-black bg-opacity-50 rounded-lg shadow-lg max-w-3xl mx-auto text-white">
      <div className="flex justify-center border-b border-gray-700 mb-6">
        <SkeletonLoader className="h-10 w-20 mr-2" />
        <SkeletonLoader className="h-10 w-20 mr-2" />
        <SkeletonLoader className="h-10 w-20 mr-2" />
        <SkeletonLoader className="h-10 w-20" />
      </div>
      <div className="animate-fadeIn">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 text-center">
          <SkeletonLoader className="h-20" />
          <SkeletonLoader className="h-20" />
          <SkeletonLoader className="h-20" />
        </div>
        <div className="bg-gray-800/50 p-4 rounded-lg flex items-center mb-6">
          <SkeletonLoader className="w-20 h-20 rounded-full mr-4" />
          <div className="flex-grow">
            <SkeletonLoader className="h-7 w-1/2 mb-2" />
            <SkeletonLoader className="h-4 w-3/4" />
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-gray-700">
          <SkeletonLoader className="h-6 w-1/3 mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col gap-2">
              <SkeletonLoader className="h-10" />
              <SkeletonLoader className="h-10" />
            </div>
            <div className="flex flex-col gap-2">
              <SkeletonLoader className="h-10" />
              <SkeletonLoader className="h-10" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletHubSkeleton;
